import { createTheme, type PaletteOptions } from "@mui/material/styles";

const lightPalette: PaletteOptions = {
  mode: "light",
  primary: { main: "#00615F" },
  secondary: { main: "#1F6600" },
  background: { default: "#FFFFFF", paper: "#FFFFFF" },
};

const darkPalette: PaletteOptions = {
  mode: "dark",
  primary: { main: "#5DD0CC" },
  secondary: { main: "#4FBA6D" },
  background: { default: "#06100E", paper: "#06100E" },
};

const typography = {
  fontFamily: '"Open Sans", "Roboto", "Helvetica", "Arial", sans-serif',
};

export const lightTheme = createTheme({ palette: lightPalette, typography });
export const darkTheme = createTheme({ palette: darkPalette, typography });
